import React, { useState, useEffect } from 'react';
import { MakeAxiosRequest } from '../../utils/handler';
import { fetchNotificationCount } from '../../features/authSlice';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import WebViewModal from '../../Components/details/WebViewModal';

function Notifications({ notifications, count,handleShow }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [viewUrl, setViewUrl] = useState('');

  const markAsRead  = async (notification) => {
    try {
        const response = await MakeAxiosRequest("post","/markasread",{notification_uuid:notification.notification_uuid	});
        // console.log(response)
        if (response.status == 1) {
          dispatch(fetchNotificationCount());
          if(notification.notificationtype =='estimate'){
            handleShow(notification.key,'estimatedetails');
            // navigate('/estimates/ongoing');
    
           }else if(notification.notificationtype =='invoice' || notification.notificationtype =='reminder'){
            handleShow(notification.invoiceKey,'invoicedetails');
            // navigate('/invoices/ongoing');
           }
        } else {
            console.log(response);
        }
    } catch (error) {
        console.error("Error", error);
    }
  }
  const clearNotifications = async () => {
    try {
        const response = await MakeAxiosRequest("post", "/clearallnotification");
        // console.log(response)
        if (response.status == 1) {
          dispatch(fetchNotificationCount());
        } else {
            console.log(response);
        }
    } catch (error) {
        console.error("Error", error);
    }
  }

  return (
    <>
      {notifications.length > 0 ? (
        <React.Fragment>
          <li className="notfctn-lst-hd d-flex justify-content-between flex-wrap px-3 py-2 border-bottom-0 align-items-end">
                    <h4 className="m-0">Notifications</h4>
                    {count > 0 &&  <a href='javascript:void(0)' onClick={clearNotifications}>Clear All Notifications</a> }
          </li>
           
            {notifications.map((notification, optionIndex) => (
                
                <li className={notification.is_read ==1 ? "notfctn-lst px-3 py-2 fadeText" : "notfctn-lst px-3 py-2"}>
                <a href='javascript:void(0)' className="d-flex align-items-baseline justify-content-between">
                  <div className="d-flex">
                    <div key={optionIndex} onClick={() => markAsRead(notification)}>
                      <h6>{notification.title}</h6>
                      <p>{notification.label}</p>
                      <small className="ntfcn-date d-block">{notification.timeLabel}</small>
                    </div>
                  </div>
                  {notification.is_read !='1' &&<div className="d-flex align-items-center">
                    <span className="online-indctn"></span>
                  </div>}
                </a>
              </li>
             
                
              ))
            
          }
        </React.Fragment>

      ) :
      <p className='no-notf-records'>No notifications Found</p>}

      {count > 2 &&
        <div className="text-center">
          <Link className="link small" to={"/notifications"}>View all notifications</Link>
        </div>
      }
    </>
  )
}

export default Notifications